module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.akTypographyMixins = exports.akHelperMixins = exports.akElevationMixins = void 0;
    var _keys = __webpack_require__(2), _keys2 = _interopRequireDefault(_keys), _assign = __webpack_require__(3), _assign2 = _interopRequireDefault(_assign), _elevation = __webpack_require__(4);
    Object.defineProperty(exports, "akElevationMixins", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_elevation).default;
        }
    });
    var _helpers = __webpack_require__(9);
    Object.defineProperty(exports, "akHelperMixins", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_helpers).default;
        }
    });
    var _tyopgraphy = __webpack_require__(10);
    Object.defineProperty(exports, "akTypographyMixins", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_tyopgraphy).default;
        }
    });
    var req = __webpack_require__(13), intVariableNames = [ "akGridSizeUnitless", "akZIndexNavigation", "akZIndexLayer", "akZIndexBlanket", "akZIndexFlag", "akZIndexCard", "akZIndexDialog", "akZIndexModal" ];
    exports.default = req.keys().reduce(function(prev, file) {
        var vars = req(file);
        return (0, _assign2.default)(prev, vars), (0, _keys2.default)(vars).forEach(function(varName) {
            intVariableNames.indexOf(varName) > -1 ? module.exports[varName] = parseInt(vars[varName], 10) : module.exports[varName] = vars[varName];
        }), prev;
    }, {});
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/keys");
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/assign");
}, /* 4 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(5), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-shadow: 0 1px 1px ", ", 0 0 1px 0 ", ";\n  z-index: ", ";\n" ], [ "\n  box-shadow: 0 1px 1px ", ", 0 0 1px 0 ", ";\n  z-index: ", ";\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n  z-index: ", ";\n" ], [ "\n  box-shadow: 0 4px 8px -2px ", ", 0 0 1px ", ";\n  z-index: ", ";\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-shadow: 0 8px 16px -4px ", ", 0 0 1px ", ";\n  z-index: ", ";\n" ], [ "\n  box-shadow: 0 8px 16px -4px ", ", 0 0 1px ", ";\n  z-index: ", ";\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-shadow: 0 20px 32px -8px ", ", 0 0 1px ", ";\n  z-index: ", ";\n" ], [ "\n  box-shadow: 0 20px 32px -8px ", ", 0 0 1px ", ";\n  z-index: ", ";\n" ]), _styledComponents = __webpack_require__(6), _colors = __webpack_require__(7), _zIndexes = __webpack_require__(8), _zIndexes2 = _interopRequireDefault(_zIndexes), e100 = (0, 
    _styledComponents.css)(_templateObject, _colors.akColorN50A, _colors.akColorN60A, _zIndexes2.default.akZIndexCard), e200 = (0, 
    _styledComponents.css)(_templateObject2, _colors.akColorN60A, _colors.akColorN60A, _zIndexes2.default.akZIndexDialog), e500 = (0, 
    _styledComponents.css)(_templateObject3, _colors.akColorN60A, _colors.akColorN60A, _zIndexes2.default.akZIndexModal), e600 = (0, 
    _styledComponents.css)(_templateObject4, _colors.akColorN50A, _colors.akColorN60A, _zIndexes2.default.akZIndexFlag);
    exports.default = {
        e100: e100,
        e200: e200,
        e500: e500,
        e600: e600
    };
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = {
        akColorPrimary1: "#172B4D",
        akColorPrimary2: "#0049B0",
        akColorPrimary3: "#FFFFFF",
        akColorSecondary1: "#FF5630",
        akColorSecondary2: "#FFAB00",
        akColorSecondary3: "#36B37E",
        akColorSecondary4: "#6554C0",
        akColorSecondary5: "#00B8D9",
        akColorR50: "#FFEBE6",
        akColorR75: "#FFBDAD",
        akColorR100: "#FF8F73",
        akColorR200: "#FF7452",
        akColorR300: "#FF5630",
        akColorR400: "#DE350B",
        akColorR500: "#BF2600",
        akColorY50: "#FFFAE6",
        akColorY75: "#FFF0B3",
        akColorY100: "#FFE380",
        akColorY200: "#FFC400",
        akColorY300: "#FFAB00",
        akColorY400: "#FF991F",
        akColorY500: "#FF8B00",
        akColorG50: "#E3FCEF",
        akColorG75: "#ABF5D1",
        akColorG100: "#79F2C0",
        akColorG200: "#57D9A3",
        akColorG300: "#36B37E",
        akColorG400: "#00875A",
        akColorG500: "#006644",
        akColorB50: "#DEEBFF",
        akColorB75: "#B3D4FF",
        akColorB100: "#4C9AFF",
        akColorB200: "#2684FF",
        akColorB300: "#0065FF",
        akColorB400: "#0052CC",
        akColorB500: "#0049B0",
        akColorP50: "#EAE6FF",
        akColorP75: "#C0B6F2",
        akColorP100: "#998DD9",
        akColorP200: "#8777D9",
        akColorP300: "#6554C0",
        akColorP400: "#5243AA",
        akColorP500: "#403294",
        akColorT50: "#E6FCFF",
        akColorT75: "#B3F5FF",
        akColorT100: "#79E2F2",
        akColorT200: "#00C7E6",
        akColorT300: "#00B8D9",
        akColorT400: "#00A3BF",
        akColorT500: "#008DA6",
        akColorN0: "#FFFFFF",
        akColorN10: "#FAFBFC",
        akColorN20: "#F4F5F7",
        akColorN30: "#EBECF0",
        akColorN40: "#DFE1E6",
        akColorN50: "#C1C7D0",
        akColorN60: "#B3BAC5",
        akColorN70: "#A5ADBA",
        akColorN80: "#97A0AF",
        akColorN90: "#8993A4",
        akColorN100: "#7A869A",
        akColorN200: "#6C798F",
        akColorN300: "#5E6C84",
        akColorN400: "#505F79",
        akColorN500: "#42526E",
        akColorN600: "#344563",
        akColorN700: "#253858",
        akColorN800: "#172B4D",
        akColorN900: "#091E42",
        akColorN10A: "rgba(9, 30, 66, 0.02)",
        akColorN20A: "rgba(9, 30, 66, 0.04)",
        akColorN30A: "rgba(9, 30, 66, 0.08)",
        akColorN40A: "rgba(9, 30, 66, 0.13)",
        akColorN50A: "rgba(9, 30, 66, 0.25)",
        akColorN60A: "rgba(9, 30, 66, 0.31)",
        akColorN70A: "rgba(9, 30, 66, 0.36)",
        akColorN80A: "rgba(9, 30, 66, 0.42)",
        akColorN90A: "rgba(9, 30, 66, 0.48)",
        akColorN100A: "rgba(9, 30, 66, 0.54)",
        akColorN200A: "rgba(9, 30, 66, 0.60)",
        akColorN300A: "rgba(9, 30, 66, 0.65)",
        akColorN400A: "rgba(9, 30, 66, 0.71)",
        akColorN500A: "rgba(9, 30, 66, 0.77)",
        akColorN600A: "rgba(9, 30, 66, 0.82)",
        akColorN700A: "rgba(9, 30, 66, 0.89)",
        akColorN800A: "rgba(9, 30, 66, 0.95)"
    };
}, /* 8 */
/***/
function(module, exports) {
    module.exports = {
        akZIndexCard: "100",
        akZIndexDialog: "200",
        akZIndexNavigation: "300",
        akZIndexLayer: "400",
        akZIndexBlanket: "500",
        akZIndexModal: "510",
        akZIndexFlag: "600"
    };
}, /* 9 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(5), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  &:focus {\n    box-shadow: 0 0 0 ", " ", ";\n    outline: none;\n  }\n" ], [ "\n  &:focus {\n    box-shadow: 0 0 0 ", " ", ";\n    outline: none;\n  }\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n" ], [ "\n  ", "\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-shadow: none;\n" ], [ "\n  box-shadow: none;\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  max-width: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n" ], [ "\n  max-width: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n" ]), _styledComponents = __webpack_require__(6), _colors = __webpack_require__(7), createFocusRing = function() {
        var color = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _colors.akColorB100, width = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "2px";
        return (0, _styledComponents.css)(_templateObject, width, color);
    }, withFocusRing = (0, _styledComponents.css)(_templateObject2, createFocusRing()), withoutFocusRing = (0, 
    _styledComponents.css)(_templateObject3), truncate = function(width) {
        return (0, _styledComponents.css)(_templateObject4, width);
    };
    // prefer default export
    exports.default = {
        focusRing: {
            generate: createFocusRing,
            default: withFocusRing,
            none: withoutFocusRing
        },
        text: {
            truncate: truncate
        }
    };
}, /* 10 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(5), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  font-size: ", "em;\n  font-style: inherit;\n  line-height: ", ";\n" ], [ "\n  font-size: ", "em;\n  font-style: inherit;\n  line-height: ", ";\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n" ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n" ]), _templateObject7 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n" ], [ "\n  ", "\n  color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n" ]), _templateObject8 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n" ]), _templateObject9 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  color: ", ";\n  font-weight: normal;\n  margin-top: ", "px;\n" ], [ "\n  ", "\n  color: ", ";\n  font-weight: normal;\n  margin-top: ", "px;\n" ]), _styledComponents = __webpack_require__(6), _colors = __webpack_require__(7), _colors2 = _interopRequireDefault(_colors), _fonts = __webpack_require__(11), _fonts2 = _interopRequireDefault(_fonts), _grid = __webpack_require__(12), _grid2 = _interopRequireDefault(_grid), fontSizeDefault = parseInt(_fonts2.default.akFontSizeDefault, 10), gridSize = parseInt(_grid2.default.akGridSizeUnitless, 10), baseHeading = function(fontSize, lineHeight) {
        return (0, _styledComponents.css)(_templateObject, fontSize / fontSizeDefault, lineHeight / fontSize);
    }, h900 = (0, _styledComponents.css)(_templateObject2, baseHeading(35, 40), 6.5 * gridSize), h800 = (0, 
    _styledComponents.css)(_templateObject3, baseHeading(29, 32), 5 * gridSize), h700 = (0, 
    _styledComponents.css)(_templateObject2, baseHeading(24, 28), 5 * gridSize), h600 = (0, 
    _styledComponents.css)(_templateObject4, baseHeading(20, 24), 3.5 * gridSize), h500 = (0, 
    _styledComponents.css)(_templateObject5, baseHeading(16, 20), 3 * gridSize), h400 = (0, 
    _styledComponents.css)(_templateObject6, baseHeading(14, 16), 2 * gridSize), h300 = (0, 
    _styledComponents.css)(_templateObject7, baseHeading(12, 16), _colors2.default.akColorN300, 2.5 * gridSize), h200 = (0, 
    _styledComponents.css)(_templateObject8, baseHeading(12, 16), _colors2.default.akColorN300, 2 * gridSize), h100 = (0, 
    _styledComponents.css)(_templateObject9, baseHeading(12, 16), _colors2.default.akColorN300, 2 * gridSize);
    exports.default = {
        h100: h100,
        h200: h200,
        h300: h300,
        h400: h400,
        h500: h500,
        h600: h600,
        h700: h700,
        h800: h800,
        h900: h900
    };
}, /* 11 */
/***/
function(module, exports) {
    module.exports = {
        akFontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        akFontSizeDefault: "14px",
        akCodeFontFamily: '"SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Courier, monospace'
    };
}, /* 12 */
/***/
function(module, exports) {
    module.exports = {
        akGridSizeUnitless: "8",
        akGridSize: "8px"
    };
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    function webpackContext(req) {
        return __webpack_require__(webpackContextResolve(req));
    }
    function webpackContextResolve(req) {
        return map[req] || function() {
            throw new Error("Cannot find module '" + req + "'.");
        }();
    }
    var map = {
        "./borders.less": 14,
        "./colors.less": 7,
        "./fonts.less": 11,
        "./grid.less": 12,
        "./z-indexes.less": 8
    };
    webpackContext.keys = function() {
        return Object.keys(map);
    }, webpackContext.resolve = webpackContextResolve, module.exports = webpackContext, 
    webpackContext.id = 13;
}, /* 14 */
/***/
function(module, exports) {
    module.exports = {
        akBorderRadius: "3px"
    };
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/util-shared-styles/dist/bundle-cjs.js
// module id = 77
// module chunks = 0